import {ACTION} from './constants';

let initialState={
    sipBannerData:{
        apiLoaded: false
    },
    sipDisclaimerData:{
        apiLoaded: false
    },
    sipCallUs:{
        apiLoaded: false
    },
}

export default function SipLandingReducer(state=initialState, action) {
    switch (action.type) {
        case ACTION.GET_SIP_BANNER_CONTENT:
            return {...state, sipBannerData:{...action.data, apiLoaded: true}};
        
        case ACTION.POST_SIP_CALL_US:
            return {...state, sipCallUs:{...action.data, apiLoaded: true}};
        
        case ACTION.GET_SIP_DISCLAIMER_CONTENT:
            return {...state, sipDisclaimerData:{...action.data, apiLoaded: true}};

        default:
            return state;
    }
}